import React, { useState, useEffect } from "react";
import { Box, Typography, Chip } from "@mui/material";

const CountdownTimer = ({ expiryDate }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const expiry = new Date(expiryDate).getTime();
      const difference = expiry - now;

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
        setIsExpired(false);
      } else {
        setIsExpired(true);
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [expiryDate]);

  if (isExpired) {
    return (
      <Chip
        label="Expired"
        color="error"
        size="small"
        variant="outlined"
      />
    );
  }

  return (
    <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
      <Box sx={{ textAlign: "center" }}>
        <Typography variant="caption" display="block" sx={{ fontWeight: "bold" }}>
          {timeLeft.days}
        </Typography>
        <Typography variant="caption" display="block" sx={{ fontSize: "0.7rem" }}>
          Days
        </Typography>
      </Box>
      <Typography variant="body2" sx={{ color: "text.secondary" }}>:</Typography>
      <Box sx={{ textAlign: "center" }}>
        <Typography variant="caption" display="block" sx={{ fontWeight: "bold" }}>
          {timeLeft.hours}
        </Typography>
        <Typography variant="caption" display="block" sx={{ fontSize: "0.7rem" }}>
          Hours
        </Typography>
      </Box>
      <Typography variant="body2" sx={{ color: "text.secondary" }}>:</Typography>
      <Box sx={{ textAlign: "center" }}>
        <Typography variant="caption" display="block" sx={{ fontWeight: "bold" }}>
          {timeLeft.minutes}
        </Typography>
        <Typography variant="caption" display="block" sx={{ fontSize: "0.7rem" }}>
          Minutes
        </Typography>
      </Box>
      <Typography variant="body2" sx={{ color: "text.secondary" }}>:</Typography>
      <Box sx={{ textAlign: "center" }}>
        <Typography variant="caption" display="block" sx={{ fontWeight: "bold" }}>
          {timeLeft.seconds}
        </Typography>
        <Typography variant="caption" display="block" sx={{ fontSize: "0.7rem" }}>
          Seconds
        </Typography>
      </Box>
    </Box>
  );
};

export default CountdownTimer;
